import i18n from "@/i18n";
//TODO: Eliminar fake data

const reservation = [
    {
        key: "numero",
        label: "Nro. Reserva",
        sortable: true,
    },
    {
        key: "fechaDesde",
        label: "Fecha retiro",
        sortable: true,
    },
    {
        key: "fechaHasta",
        label: "Fecha devolucion",
        sortable: true,
    },
    {
        key: "sucursalSalida",
        label: "Sucursal retiro",
        sortable: true,
    },
    {
        key: "sucursalDevolucion",
        label: "Sucursal devolucion",
        sortable: true,
    },
    {
        key: "estado",
        label: "Estado reserva",
        sortable: true,
    },
    {
        key: "contrato",
        label: "Nro. Contrato",
        sortable: true,
    },
    {
        key: "patente",
        label: "Patente",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar",
        sortable: true,
    }

];

const contract = [
    {
        key: "numero",
        label: "Nro. Contrato",
        sortable: true,
    },
    {
        key: "fechaDesde",
        label: "Fecha de inicio",
        sortable: true,
    },
    {
        key: "fechaHasta",
        label: "Fecha de devolución",
        sortable: true,
    },
    {
        key: "sucursalSalida",
        label: "Sucursal retiro",
        sortable: true,
    },
    {
        key: "sucursalDevolucion",
        label: "Sucursal devolucion",
        sortable: true,
    },
    {
        key: "estado",
        label: "Estado",
        sortable: true,
    },
    {
        key: "liquidacion",
        label: "Liquidacion",
        sortable: true,
    },
    {
        key: "factura_Boleta",
        label: "Factura/Boleta",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar Liquidación",
        sortable: true,
    },
    {
        key: "pagar",
        label: "Pagar Liquidación",
        sortable: true,
    }

];

const quotation = [
    {
        key: i18n.t('lease.quotation.table.rac.reservation.key'),
        label: i18n.t('lease.quotation.table.rac.reservation.label'),
        sortable: true,
    },
    {
        key: i18n.t('lease.quotation.table.rac.state.key'),
        label: i18n.t('lease.quotation.table.rac.state.label'),
        sortable: true,
    },
    {
        key: i18n.t('lease.quotation.table.rac.number.key'),
        label: i18n.t('lease.quotation.table.rac.number.label'),
        sortable: true,
    },
    {
        key: i18n.t('lease.quotation.table.rac.retreatDate.key'),
        label: i18n.t('lease.quotation.table.rac.retreatDate.label'),
        sortable: true,
    },
    {
        key: i18n.t('lease.quotation.table.rac.deliveryDate.key'),
        label: i18n.t('lease.quotation.table.rac.deliveryDate.label'),
        sortable: true,
    },
    {
        key: i18n.t('lease.quotation.table.rac.withdrawalBranch.key'),
        label: i18n.t('lease.quotation.table.rac.withdrawalBranch.label'),
        sortable: true,
    },
    {
        key: i18n.t('lease.quotation.table.rac.deliveryBranch.key'),
        label: i18n.t('lease.quotation.table.rac.deliveryBranch.label'),
        sortable: true,
    },
    {
        key: i18n.t('lease.quotation.table.rac.download.key'),
        label: i18n.t('lease.quotation.table.rac.download.label'),
        sortable: true,
    }

];

const reference = [
    {
        key: i18n.t('lease.reference.table.contractNumber.key'),
        label: i18n.t('lease.reference.table.contractNumber.label'),
        sortable: true,
    }, {
        key: i18n.t('lease.reference.table.reservationNumber.key'),
        label: i18n.t('lease.reference.table.reservationNumber.label'),
        sortable: true,
    }, {
        key: i18n.t('lease.reference.table.referenceType.key'),
        label: i18n.t('lease.reference.table.referenceType.label'),
        sortable: true,
    }, {
        key: i18n.t('lease.reference.table.branchOffice.key'),
        label: i18n.t('lease.reference.table.branchOffice.label'),
        sortable: true,
    }, {
        key: i18n.t('lease.reference.table.sendReference.key'),
        label: i18n.t('lease.reference.table.sendReference.label'),
        sortable: true,
    },
]

const boleta_factura = [
    {
        key: "ctaCteNroDocto",
        label: "Nro. Factura/Boleta",
        sortable: true,
    },
    {
        key: "contratO_IdContrato",
        label: "Nro. Contrato",
        sortable: true,
    },
    {
        key: "contratO_IdReserva",
        label: "Nro. Reserva",
        sortable: true,
    },
    {
        key: "evenTipoDesc",
        label: "Tipo",
        sortable: true,
    },
    {
        key: "ctaCteFecEmision",
        label: "Fecha emisión",
        sortable: true,
    },
    {
        key: "ctaCteTotal",
        label: "Monto",
        sortable: true,
    },
    {
        key: "ctaCteSaldo",
        label: "Saldo",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar",
        sortable: true,
    },
    {
        key: "pagar",
        label: "Pagar",
    }

];

export default {
    reservation,
    contract,
    quotation,
    boleta_factura,
    reference
};
